/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Development_DescriptionInputs */

const et_service_development_description = /** @type {(inputs: Service_Development_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehitame kiireid, turvaliseid ja konversioonile optimeeritud veebilehti, mis toovad tegelikult päringuid ja müüki.`)
};

const en_service_development_description = /** @type {(inputs: Service_Development_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We build fast, secure, and conversion-optimized websites that actually bring inquiries and sales.`)
};

/**
* | output |
* | --- |
* | "We build fast, secure, and conversion-optimized websites that actually bring inquiries and sales." |
*
* @param {Service_Development_DescriptionInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const service_development_description = /** @type {((inputs?: Service_Development_DescriptionInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Development_DescriptionInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_service_development_description(inputs)
	return en_service_development_description(inputs)
});